import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import { DatePickerInput } from "rc-datepicker";
import "rc-datepicker/lib/style.css";
import React from "react";
import {
  getActiveLanguage,
  getTranslate,
  Translate
} from "react-localize-redux";
import { connect } from "react-redux";
import renderHTML from "react-render-html";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Field, reduxForm } from "redux-form";
import {
  createValidator,
  email,
  match,
  maxLengthPassword,
  minLengthMobile,
  minLengthPassword,
  noSpecialChars,
  noVnChars,
  password,
  required
} from "../../helpers/validator";
import {
  showConfirmMessage,
  showMessageModal
} from "../../redux/modules/Modal";
import { getSysCodeOptions } from "../../redux/modules/SystemCode";
import { uniqueEmail } from "../../redux/modules/UniqueField";
import CountryNames from "../../resources/general/CountryName";
import CheckField from "../components/fields/CheckField";
import TextField from "../components/fields/TextField";
import Button from "../components/forms/Button";
import ModalRedeem from "../components/modal/ModalRedeem";
import MobileNumberField from "./MobileNumberField";

const customStyles = {
  content: {
    top: "10%",
    left: "10%",
    right: "10%",
    bottom: "10%",
    borderRadius: "0px"
  },
  overlay: {
    opacity: 1,
    background: "rgba(66, 63, 63, 0.75)"
  }
};
const customStylesRefer = {
  content: {
    top: "10%",
    left: "10%",
    right: "10%",
    bottom: "unset",
    borderRadius: "0px"
  },
  overlay: {
    opacity: 1,
    background: "rgba(66, 63, 63, 0.75)"
  }
};
const date = new Date();
const datenow = moment(date).format("YYYY-MM-DD");

const validate = createValidator({
  salutation: [required],
  email: [required, email],
  firstName: [required, noVnChars, noSpecialChars],
  lastName: [required, noVnChars, noSpecialChars],
  dob: [required],
  mobileNo: [required, minLengthMobile(8)],
  nationality: [required],
  consentAgreement: [],
  termsAndConditions: [required],
  countryOfResidence: [required],
  password: [required, minLengthPassword(8), maxLengthPassword(99), password],
  confirmPassword: [required, match("password")]
});

const countryNameOptions = [];
Object.keys(CountryNames).map(key => {
  return countryNameOptions.push({
    value: CountryNames[key],
    label: CountryNames[key],
    code: key
  });
});

export const formId = "sign-up";
class SignUpForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isConfirmClick: false,
      isShowModal: false,
      isShowModalRefer: false,
      countryKey: "SG",
      nationalities: [],
      isNationalitiesFetching: false,
      showOtp: false,
      dob: ""
    };
    this.handleSelectCountryOfResidence = this.handleSelectCountryOfResidence.bind(
      this
    );
  }

  componentDidMount() {
    const { initialValues } = this.props;
  }

  handleSelectCountryOfResidence(option) {
    const { countryKey } = this.state;
    const selectedOption = option ? option.code : null;
    if (selectedOption !== countryKey)
      this.setState({ countryKey: selectedOption });
  }

  fetchNationalities = url => {
    return axios.get(url);
  };
  checkEmail = () => {
    let email = this.form.email.value;
    this.props.dispatch(uniqueEmail(email));
  };

  showInputOtp = value => {
    this.setState({ showOtp: value });
  };

  handleOnChange = value => {
    let dob = moment(value).format("DD/MM/YYYY");
    if (dob != "Invalid date") {
      let dob = moment(value).format("YYYY-MM-DD");
      this.setState({ dob });
      this.props.getValueDob(dob);
    } else {
      this.props.getValueDob(dob);
    }
  };
  setGender(event) {
    let gender = event.target.value;
    this.props.getValueGender(gender);
  }

  onCancelClick = () => {
    this.setState({
      isShowModal: false,
      isShowModalRefer: false
    });
  };
  onConfirmClick = item => {
    this.setState({
      isShowModal: true,
      item: item
    });
  };
  onClickReferral = () => {
    this.setState({
      isShowModalRefer: true
    });
  };
  formatDate = date => {
    var d = new Date(),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  renderModal = contentCondition => {
    return (
      <ModalRedeem
        style={this.state.isShowModal ? customStyles : customStylesRefer}
        isOpen={true}
        onCancelClick={this.onCancelClick}
      >
        <div>{renderHTML(contentCondition)}</div>
        <div className="row">
          <div
            onClick={this.onCancelClick}
            className="modal-reg col-sm-12 col-md-12 col-12 pt-3"
          >
            <div className="btn btn-close w-100">
              <h6 className="font-title">Close</h6>
            </div>
          </div>
        </div>
      </ModalRedeem>
    );
  };

  render() {
    const {
      error,
      handleSubmit,
      displayLabel,
      pristine,
      translate,
      submitting,
      currentLanguage,
      condition,
      referral
    } = this.props;
    const { nationalities, isNationalitiesFetching } = this.state;
    let contentCondition = condition ? condition[0].contentHtml : "";
    let contentReferral = referral ? referral[0].contentHtml : "";
    return (
      <div>
        <form
          ref={form => {
            this.form = form;
          }}
          name="form"
          onSubmit={handleSubmit}
          className="row form"
        >
          <div className="col-12 pt-3">
            <label>
              <Translate id="_shared.form.label._firstName" />
            </label>
            <Field
              name="firstName"
              type="text"
              hideLabel={true}
              autocomplete="given-name"
              placeholder={displayLabel}
              required={true}
              disabled={submitting}
              component={TextField}
              label={translate("_shared.form.label._firstName")}
            />
            <label>
              <Translate id="_shared.form.label._lastName" />
            </label>
            <Field
              name="lastName"
              type="text"
              hideLabel={true}
              autocomplete="family-name"
              placeholder={displayLabel}
              defaultCode={"+65"}
              handleInputOTP={this.showInputOtp}
              required={true}
              disabled={submitting}
              component={TextField}
              label={translate("_shared.form.label._lastName")}
            />
            <label>
              <Translate id="_shared.form.label._gender" />
            </label>
            <div className="form-check form-check-inline mb-1">
              <div
                onChange={this.setGender.bind(this)}
                className="form-check form-check-inline"
              >
                <input
                  className="form-check-input mr-1"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio1"
                  value="M"
                />
                <label className="form-check-label mr-3" for="inlineRadio1">
                  Male
                </label>
                <input
                  className="form-check-input mr-1"
                  type="radio"
                  name="inlineRadioOptions"
                  id="inlineRadio2"
                  value="F"
                />
                <label className="form-check-label" for="inlineRadio2">
                  Female
                </label>
              </div>
            </div>
            <label>
              <Translate id="_shared.form.label._dob" />
            </label>
            <div className="form-group">
              <DatePickerInput
                value={this.state.dob}
                name="dob"
                // type="date"
                disabled={this.state.disabled}
                format="DD/MM/YYYY"
                displayFormat="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                returnFormat="YYYY-MM-DD"
                maxDate={this.formatDate(new Date())}
                className="my-react-component"
                onChange={dateString => this.handleOnChange(dateString)}
                showOnInputClick
                onClear={this.onClear}
                onBlur={this.handleBlur}
                readOnly
              />
            </div>
            {/* <label>
            <Translate id="_shared.form.label._email" />
          </label> */}
            <Field
              name="email"
              type="email"
              required={true}
              disabled={submitting}
              placeholder={displayLabel}
              label={"Email"}
              component={TextField}
              onBlur={this.checkEmail}
            />
            <label>
              <Translate id="_shared.form.label._mobileNo" />
            </label>
            <div className="form-group">
              <Field
                name="mobileNo"
                type="number"
                required={true}
                hideLabel={true}
                disabled={submitting}
                component={MobileNumberField}
                placeholder={displayLabel}
                minLengthMobile={8}
                defaultCode={"+65"}
                handleInputOTP={this.showInputOtp}
              />
            </div>
            {this.state.showOtp && (
              <div className="row form-group">
                <div className="otp-code col-lg-9 col-md-9 col-9">
                  <Field
                    name="otpCode"
                    type="text"
                    hideLabel={true}
                    autocomplete="given-name"
                    label="Key in your 6 digit OTP here "
                    required={true}
                    disabled={submitting}
                    component={TextField}
                  />
                </div>
              </div>
            )}
            <label>
              <Translate id="_shared.form.label._referralCode" />
            </label>
            <span className="icon-ref">
              <img
                onClick={this.onClickReferral}
                className="ml-1"
                src="images/icons/icon-i.svg"
              />
            </span>
            <Field
              name="referralCode"
              type="text"
              hideLabel={true}
              autocomplete="given-name"
              placeholder={displayLabel}
              required={false}
              disabled={submitting}
              component={TextField}
              label={translate("_shared.form.label._referralCode")}
            />
            <Field
              name="password"
              type="password"
              autocomplete="given-name"
              placeholder={displayLabel}
              required={true}
              minLengthPassword={8}
              maxLengthPassword={15}
              disabled={submitting}
              component={TextField}
              label={"Password"}
            />
            <Field
              name="confirmPassword"
              type="password"
              autocomplete="given-name"
              placeholder={displayLabel}
              match={"Password"}
              required={true}
              disabled={submitting}
              component={TextField}
              label={"Confirm Password"}
            />
            <div className="row mx-2 ml-1 color-text-2">
              <div className="col-12 tncEmail">
                <Field
                  id="tncEmail"
                  name="tncEmail"
                  type="checkbox"
                  disabled={submitting}
                  component={CheckField}
                  label={
                    <span className="txt">
                      <Translate id="_tncEmail" />
                    </span>
                  }
                  className="font-sub"
                />
              </div>
              <div className="col-12 tncAgree d-sm-block d-lg-block d-md-block">
                <Field
                  id="tncAgree"
                  name="tncAgree"
                  type="checkbox"
                  disabled={submitting}
                  component={CheckField}
                  label={
                    <p className="txt">
                      I am signing up to become a Mr. Coconut Loyalty member and
                      I accept the{" "}
                      <span
                        onClick={this.onConfirmClick}
                        className="back-link card-text"
                      >
                        <u>general terms & conditions of use</u>
                      </span>
                    </p>
                  }
                  className="font-sub"
                />
              </div>
            </div>
            {error && (
              <div className="my-2 text-left">
                <span className="form-error">{error}</span>
              </div>
            )}
          </div>

          <div className="col-12 text-left mt-2">
            <div className="row">
              <div className="col-8 text-left mt-3">
                <div className="pt-1">
                  <Button
                    type="submit"
                    className="btn btn-primary btn-reg"
                    disabled={pristine}
                    loading={submitting}
                  >
                    <Translate id={submitting ? "_Submitting" : "_register"} />
                  </Button>
                </div>
                <div className="back-link pt-5">
                  <Link to={`/sign-in`} className="back-link">
                    <u>
                      <Translate id="_backToLogin" />
                    </u>
                  </Link>
                </div>
              </div>
              <div className="col-4 icon-reg text-center ml--3 mt-3">
                <img className="" src="images/icon-coconut-reg.png" />
              </div>
            </div>
          </div>
        </form>
        {this.state.isShowModal && this.renderModal(contentCondition)}
        {this.state.isShowModalRefer && this.renderModal(contentReferral)}
      </div>
    );
  }
}

SignUpForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired
};

const mapStateToProps = ({ locale, cms }) => ({
  translate: getTranslate(locale),
  currentLanguage: getActiveLanguage(locale).code,
  condition: cms.condition,
  referral: cms.referral
});

const mapDispatchTpProps = dispatch => ({
  getSysCodeOptions: bindActionCreators(getSysCodeOptions, dispatch),
  showConfirmMessage: bindActionCreators(showConfirmMessage, dispatch),
  showMessageModal: bindActionCreators(showMessageModal, dispatch)
});

export default reduxForm({
  form: formId, // a unique identifier for this form
  validate,
  enableReinitialize: true,
  destroyOnUnmount: false
})(connect(mapStateToProps, mapDispatchTpProps)(SignUpForm));



// WEBPACK FOOTER //
// ./src/views/modules/SignUpForm.js